import {
  GridRenderCellParams,
  useGridSelector,
  useGridApiContext,
  gridDetailPanelExpandedRowsContentCacheSelector,
} from '@mui/x-data-grid-pro';
import ChevronDown from '@old/assets/svg/chevron-down.svg';
import { Button } from '@mui/material';
import React from 'react';
import i18n from '../../../libs/language';

export function CustomDetailPanelToggle(props: Pick<GridRenderCellParams, 'id' | 'value'>) {
  const { id, value: isExpanded } = props;
  const apiRef = useGridApiContext();
  const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);
  const hasDetail = React.isValidElement(contentCache[id]);
  return (
    <Button
      endIcon={<img src={ChevronDown} />}
      size="small"
      tabIndex={-1}
      disabled={!hasDetail}
      aria-label={isExpanded ? 'Close' : 'Open'}
      sx={{
        color: '#22A7F0',
        fontSize: 13,
        padding: '0 8px',
        textTransform: 'none',
        background: isExpanded ? '#22A7F05A' : 'transparent',
        '&:hover': { background: '#22A7F02A' },
      }}
    >
      {!isExpanded ? i18n.t('app.report_stock.see_detail') : 'Cerrar detalle'}
    </Button>
  );
}
